<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">建値（支払条件）詳細</span>
      </v-card-title>
      <v-card-actions>
        <v-btn
          :disabled="!valid || !$hasLength(form.code) || !$hasLength(form.name)"
          @click="save"
          v-permit.SHARP_INCOTERM_NEW
          >{{ $t("app.buttons.save") }}</v-btn
        >
        <v-btn @click="$router.go(-1)">{{ $t("app.buttons.back") }}</v-btn>
      </v-card-actions>
      <v-form v-model="valid">
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs6>
              <v-text-field
                :disabled="form.id"
                :rules="codeRules"
                clearable
                label="建値（支払条件）CD"
                v-model.trim="form.code"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md3 sm6 xs6>
              <v-text-field
                :rules="nameRules"
                clearable
                label="建値（支払条件）名称"
                v-model.trim="form.name"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      valid: false,
      form: {},
      nameRules: [(v) => !!v || "Name is required"],
      codeRules: [(v) => !!v || "Code is required"],
      errors: {
        CODE_EXISTS: "当該CDは既に存在しています。",
      },
    };
  },
  methods: {
    save() {
      this.$http
        .post("/incoterms", this.form)
        .then(() => {
          this.$router.go(-1);
        })
        .catch((err) => {
          this.$showError(err);
        });
    },
  },
};
</script>
